"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RankedValue = exports.Rank = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Rank = function Rank(_ref) {
  var current = _ref.current,
      total = _ref.total;
  return current ? /*#__PURE__*/_react["default"].createElement(_styled.RankContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.Ranking, null, current), "/", /*#__PURE__*/_react["default"].createElement("span", null, total)) : null;
};

exports.Rank = Rank;

var RankedValue = function RankedValue(_ref2) {
  var current = _ref2.current,
      total = _ref2.total,
      maxRankNumerator = _ref2.maxRankNumerator,
      minRankNumerator = _ref2.minRankNumerator,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_styled.MaxRankContainer, {
    top: current && (current === 1 || current === minRankNumerator),
    bottom: current && (current === total || current === maxRankNumerator)
  }, children);
};

exports.RankedValue = RankedValue;

//# sourceMappingURL=Rank.js.map